import React from "react"
import PropTypes from 'prop-types'
import {FieldAutomationActionFormProps} from "../../../../render/automation-action-form";
// import EditableInput from "./inline-editable/input-component";



const debug = false
// const debug = "AddressActionForm"

export default class FieldAddress_AutomationActionForm extends React.Component<any,any> {

    static propTypes = {
        field           : PropTypes.object,
        config          : PropTypes.object,

        onChangeCallback: PropTypes.func,
    }

    constructor(props:FieldAutomationActionFormProps) {
        super(props)

        this.state = {
            toValue: _.get(props.config, 'toValue', '')
        }
    }

    onChangeContentValue = (toValue:any) => {
        this.setState({
            toValue
        }, ()=>{
            this.props.onChangeCallback({toValue})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state.validationType, this.state.value)

        const labelClasses = Classes("label", {
            'w-100': this.props.field.isCustom
        })

        const fieldId = this.props.field.fieldId

        const data = {[fieldId]: this.props.config.toValue}

        return (
            <React.Fragment>
                <div className="flex-row-left-center">
                    <div className={labelClasses}>to</div>
                    <this.props.field.renderComponents.formElementView field    = {this.props.field}
                                                                       model    = {data}
                                                                       onChange = {this.onChangeContentValue}/>
                </div>
            </React.Fragment>
        )
    }

}
